import { render, staticRenderFns } from "./test.vue?vue&type=template&id=1e848987&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=1e848987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e848987",
  null
  
)

export default component.exports